module.exports = "<dt-content-header state-title=\"'Users & Access'\"></dt-content-header> <dt-tabs class=dt-tabs layout=column tabs=$ctrl.tabs on-tab-click=$ctrl.onTabClick($event)> </dt-tabs> <div ui-view=contentBody></div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/users-and-access/users-and-access.html
// module id = J4ii
// module chunks = 1